import PropTypes from "prop-types"
const { FooterSection } = require("@/components/footer-section");
const { HeaderSection } = require("@/components/header-section");

const Layout = ({children}) => {
 
  return (
    <>
      <HeaderSection />
      {children}
      {/* <FooterSection /> */}
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.any
}

export default Layout;